import type { WhatsappGroup } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { Badge, Card, Typography } from '../ui';
import { useTranslation } from '../../../lib/i18n';
import { whatsappGroupBadge } from '../../settings/shared/whatsapp-group-status';
import { useWhatsappGroupSubtitle } from './use-whatsapp-labels';
import styles from './GroupCard.module.css';

// One group in the Groups list (Figma 14077-197325): an outline (bordered) card whose top row
// carries the subject on the leading edge and the status badge on the trailing edge, over the
// "N participants · <mode>" line. The whole tile opens the group's settings, so it is a
// <Card component="button"> — same call as TaskCard.
export function GroupCard({ group, selected, onOpen }: { group: WhatsappGroup; selected: boolean; onOpen: () => void }) {
  const { t } = useTranslation();
  const subtitle = useWhatsappGroupSubtitle();
  const badge = whatsappGroupBadge(group.status);

  return (
    <Card
      variant="outline"
      component="button"
      size="sm"
      interactive
      selected={selected}
      className={styles.card}
      aria-pressed={selected}
      onClick={onOpen}
    >
      <span className={styles.head}>
        <Typography className={styles.subject} variant="h4" color="strong" component="span" noWrap>
          {group.subject}
        </Typography>
        <Badge variant={badge.variant} label={t(badge.labelKey)} />
      </span>
      <Typography className={styles.subtitle} variant="p2" color="secondary" component="span" noWrap>
        {subtitle(group)}
      </Typography>
    </Card>
  );
}
